import React from "react";

export const ChromeExtension = ({ ui }) => {
  return (
    <div id="chrome-extension" className="text-center chrome-extension-section">
      <div className="container">
        <div className="section-title">
          <h2>{ui?.title}</h2>
        </div>

        <div className="row">
          <div className="col-md-8 col-md-offset-2">
            <p className="chrome-extension-copy">{ui?.paragraph1}</p>
            <p className="chrome-extension-copy">{ui?.paragraph2}</p>
            {ui?.points?.length ? (
              <ul className="chrome-extension-points">
                {ui.points.map((point) => (
                  <li key={point}>{point}</li>
                ))}
              </ul>
            ) : null}
          </div>
        </div>
      </div>
    </div>
  );
};
